import type { ReactNode } from "react";
import Button from "~/components/common/Button";
import styles from "./ConfirmModal.module.css";

type ConfirmModalProps = {
  open: boolean;
  title: ReactNode;
  content?: ReactNode;
  okText: string;
  cancelText?: string;
  /** 单按钮模式：隐藏 ghost 取消按钮（遮罩点击仍触发 onCancel） */
  hideCancel?: boolean;
  okDanger?: boolean;
  okDisabled?: boolean;
  /** 按钮行最左侧的额外内容（如「停止招聘」这类危险入口），自行负责间距与样式 */
  footerLeft?: ReactNode;
  /** sm = 320px 窄弹窗 + 15px/500 标题（对齐设计稿 #stopBox），默认 420px */
  size?: "md" | "sm";
  onOk: () => void;
  onCancel: () => void;
};

// 自绘确认弹窗，对齐设计稿 modal-mask / modal（mine.html / form.html）
const ConfirmModal = ({
  open,
  title,
  content,
  okText,
  cancelText = "取消",
  hideCancel = false,
  okDanger = false,
  okDisabled = false,
  footerLeft,
  size = "md",
  onOk,
  onCancel,
}: ConfirmModalProps) => {
  if (!open) return null;

  const small = size === "sm";

  return (
    <div
      className={styles.mask}
      onClick={onCancel}
    >
      <div
        className={`${styles.modal} ${small ? styles.modalSm : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`${styles.title} ${small ? styles.titleSm : ""}`}>{title}</div>
        {content != null && <div className={styles.body}>{content}</div>}
        <div className={styles.btns}>
          {footerLeft}
          {!hideCancel && (
            <Button
              size="sm"
              ghost
              disabled={okDisabled}
              onClick={onCancel}
            >
              {cancelText}
            </Button>
          )}
          <Button
            size="sm"
            className={okDanger ? styles.danger : undefined}
            disabled={okDisabled}
            onClick={onOk}
          >
            {okText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
